<template>
  <div class="dashboard">
	<div>
		<p></p>
    <div v-html="formIntro" v-bind:class="{ magenta: infoAlert }"></div>
		<br/>
		<div style="max-width:480px">
		<div id="dynForm" v-show="dynForm">
    <div v-for="sInput in formComponent" :key="sInput.name">
      <div class="form-group">
        <span style="font-size:18px;">{{sInput.title}}</span><img v-show="sInput.help" style="width:2.4rem;margin-left:1rem;margin-bottom:4px;" class="masterTooltip" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAFl0lEQVR4nO2dS2icVRiGH20KotiSFtGFVomCUvCCm4ILRWlQES2Isd4Qg7TRVhF1UTFScONOULLQIt2UilJE6c2NolAllnqpbVVQVDSgtF5qvKS1jaYu/gmIEOd8/5xz3n/mfA+8my7mfN/7vmQ6M/8/A47jOI7jOI7jOI7jOI7jODE4BxgEhoDbXEEaApYDZ9fwuxEsAtYDXwInXB3pC2AU6DclIOQe4DB643pNPwF3hseQn5OAZ9Eb1et6OjSQ3DyF3pxS9GRgJtkYBGbQG1OKZoCrg5LJwMnAZ+hNKU37qZ525VyP3oxSNRiQT3I2ojeiVG0IyCc5n6I3olQdCMgnOX+gN6JU/R6QT3LUJoTqb2AvsAl4AlgN3NHS6ta/bQI+prte0chRG/B/mga2AyuxvZW6iOo9+R2tx1Dv4QUw6gjVu5IxPkxZAowBRxuwlxcgQNuA8xLsOQDsbMB+XoA5NAUMJ94VYBXN+msgR23ACeB74NLUi/6Ly4GDCfbwAtTQ16T5k9+OAeBb46xegMg6BFyQfsU5uZDqc3ovgEDTwBUZ9mvHVcBfeAGya12O5QJZjxcgqz4C5uVYLpA+4BO8ANlU90//QuB+qvcKJoDjLU0AW4ERYEHNx76mxh5egBp6s8aM84HHgV8DHn+S6umlr8Y570TYzwvQRtca5zsDGK9xzi5gsfGsmxLu7QUAvqO6BC2Ufjp7bt5H9bQRSh/wQ0Y/iivAM8bZdkQ481Xjmc8l2NsL0NKNhrlujXjuCsO5Qxn9KK4Als/090c89wPDuWdl9KOoAhwyzHRZgvOXGs7/JYMfxRVg3DDTwwnOX2s4//0MfhRXgNcNM21IcP6Y4fw3MvhRXAF2E35/fZ3X/e202eDJaxl9kZNrUbU2GjzZnnEuOepgcmnU4MnujHPJUQeTS5a7cX/MOJccdTA5dJDwD4eWZJ5NjjqcHHrM4Mdw5tnkqMNJrc+BUwx+5L53QI46oJT6DbjE4MW55L8+UI46pFSaorrg08LzgjnlqINKoSNUl3hZuBjN1cFy1GHF1lHsX70yn+oTQ8W8ctSBxdSfwHU1PMh9EYgXIIGOATfU2H9UPLccdXAxdBzbVT+zPNqA2eWoDehU08DNNfZ+sAGzewE61Axwe42dR2jO9wjJURvQiSxv8c4yTHPC9wJ0oG01dr2L6tvG1LN7ATrUz8CZxj1Xor0N3AsQUWuMOy6neqWgntsLEEFfYbvx83zyXubtBUisBwy79QF7GjCzFyCSprDd//9QA2b2AkTUFsNep5L32j4vQAbdbdhrVQPm9QJE1oBhr7cbMK8XIKImDTudRvO/JdwLYNSHhp2ubMC8XoDI2mnY6b4GzOsFiCzLK4Bu+hFMOWoDQvWyYacXGjCvFyCyLAV4qQHzegEia5zw7xfIeXevF8DlBXB5AVw1JUdtQOmSozagdMlRG1C65KgNKF1y1AaULjlqA0qXHLUBpUuO2oBQvQvcEqj3GjCvFyCyLB8GvdKAeb0AkeUFSITaAC+AGLUBXgAxagO8AGLUBngBxKgN8AKIURvgBRCjNsALIEZtgBdATFO/OqUEHQvIJzkT6I0oVd+0jyc9W9EbUaqsv2yehBH0RpSqewPySc4Cqnvv1WaUpsPA6QH5ZGEdekNK0yNByWSiD9iF3pRS9BYwLyiZjCwG9qE3p9e1F+gPzCQ7C6n+Z6o2qVe1Bdv3HMpYge5HlHpRe6j3czZylgJrgTHgRaq3Y2NL+QpkMtFOm1uerQEuMrteGMvQlGCydbbTAHKXwMNvILlK4OE3mNQl8PC7gFQl8PC7iNgl8PC7kFgl8PC7mE5L4OH3AHVL4OH3ENYSePg9SGgJPPwepl0JPPwCmKsEHn5B/LcEHn6BzJbAwy+YZXj4juM4juM4Tmn8A7ecfIuQ0nQNAAAAAElFTkSuQmCC" v-bind:title="sInput.help">					
        <input type="text" class="form-control" v-model="sInput.value" v-bind:class="{ invalid: sInput.isErr }">
      </div>
    </div>
	<p>&nbsp;</p>
    <div v-html="formError" style="color:#e20074;text-align:center;font-size:1.7rem;" class="form-group"></div>
      <input value="Overiť" id="validate" class="btn btn-magenta" title="" type="button" style="width:100%" v-on:click="sendData()">
      <p></p>
    </div>
    <p v-show="retryMsisdn"> <a class="link" v-on:click="states.verify=!states.verify;states.start=!states.start;states.msisdnError='&nbsp;';states.mainPage=!states.mainPage;states.verifPages=!states.verifPages" style="cursor:pointer">{{ retryText }}</a></p>
    <p v-show="retryForm && !retryMsisdn"> <a class="link" v-on:click="dynForm=!dynForm;retryForm=!retryForm;states.msisdnError='&nbsp;';formIntro=formIntroDef" style="cursor:pointer">Upraviť údaje na overenie</a></p>
  </div>
	</div>
  </div>
</template>

<script>
import formDef from '@/assets/js/formDef'
export default {
  name: 'Actions',
  props: ['states', 'verifData', 'bpn', 'msisdn', 'scenarioType'],
  data() {
    return {
    msg: 'Váš ID kód', 
    formDef: formDef,
    formComponent: [],
    formIntro: '<strong>Doplňte zmluvné údaje. Všetky položky sú pre účely overenia povinné.</strong>',
    formIntroDef: '',
    dynForm: false,
    infoAlert: false,
    formError: "&nbsp;",
    retryMsisdn: false, retryForm: false, retryText: "Prihlásiť sa iným číslom"
    }
  },
  mounted: function() {
    if (this.verifData.scenario) {
    switch(this.verifData.scenario) {
      case 'residential':
        this.dynForm = true
        this.formComponent = this.formDef.resid
          if (this.verifData.billingProfileNumOk === false) {
            if (this.verifData.withCompare !== undefined && !this.verifData.withCompare) {
              this.dynForm = false;
              this.formIntro = "<p>Váš ID kód <strong>nie je možné zobraziť</strong>. Prihlásené telefónne číslo 0" + this.msisdn + " neevidujeme ako kontaktné číslo pre adresáta " + this.bpn + ".</p><p>Môžete si ho zmeniť na stránke <a href='/kontaktne-udaje' target='_top'>Aktualizácia kontaktných údajov</a>.</p>";
              this.retryMsisdn = true;
            } else {
              this.formIntro = "<p>Váš ID kód <strong>nie je možné zobraziť</strong>. Prihlásené telefónne číslo 0" + this.msisdn + " neevidujeme ako kontaktné číslo pre adresáta " + this.bpn + ".</p> <p>Doplňte svoje osobné údaje nižšie, pripomenieme vám evidované kontaktné číslo, ktorým sa môžete prihlásiť.</p>";
            }
            this.infoAlert = false;
          } 
        break;
      case 'business':
        this.dynForm = true
        this.formComponent = this.formDef.business
        break;
      case 'denied':
        this.dynForm = false
        if ((this.verifData.pinOk !== undefined) && (this.verifData.pinOk === false)) {
        this.formIntro = "Pre vaše IČO ešte nebol vygenerovaný PID kód. Kontaktujte prosím biznis linku <span style=\"white-space: nowrap;\">0800 123 500</span> alebo navštívte ktorékoľvek Telekom Centrum za účelom vygenerovania PID kódu."
        } else {
        this.formIntro = "<strong>Pre poskytnutie PID kódu kontaktujte vám prideleného obchodníka alebo biznis linku <span style=\"white-space: nowrap;\">0800 123 500</span>.</strong>"
        this.infoAlert = true;
        }
        this.retryMsisdn = true;
        break;
    } 
    } else {
        this.dynForm = false
        if (this.verifData.message === "not-found") {
          this.formIntro = "Číslo adresáta " + this.bpn.replace(/ /g, '') + " sme nenašli."
        } else {
          this.formIntro = "CHYBA SPRACOVANIA."
        }
        this.infoAlert = true;
        this.retryMsisdn = true;
    }
},
  created: function() {
    var that = this
    this.formIntroDef = _.clone(this.formIntro)
    window.history.pushState(null, '')
    window.onpopstate = function(event) {
    window.history.replaceState(null, '')
    that.states.verify=!that.states.verify
    that.states.start=!that.states.start
    that.states.msisdnError='&nbsp;'
    that.states.mainPage=!that.states.mainPage
    that.states.verifPages=!that.states.verifPages
    that.infoAlert = false
	  $('.masterTooltip').tooltip()
    }    
  },
  methods: {
    sendData: function() {
      var that = this 
      this.infoAlert = false
      var formValid = true, failCount = 0
      _.each(this.formComponent, function(v,k){

				if ((v.name != 'surName') && (v.name != 'fName')) {
          v.value = (v.value).replace(/(\r\n|\n|\r| )/gm, '') 
        } else {
          v.value = (v.value).replace(/(\r\n|\n|\r)/gm, ''); 
        }
        switch (v.name) {
          case 'surName':        
          case 'fName':  
           if (v.value.length < 3) {
              formValid = false
              failCount++
              v.isErr = true
            } else {
              v.isErr = false
            }
          break;
          case 'personalId':        
            v.value = (v.value).replace(/\//gm, '');
            if ((v.value.length < 9) || (v.value.length > 10) || (isNaN(v.value))) {
              formValid = false;
              failCount++;
              v.isErr = true
            } else {
              v.isErr = false
            }
          break;
          case 'companyReg':        
            if (v.value.length < 6) {
              formValid = false;
              failCount++;
              v.isErr = true
            } else {
              v.isErr = false
            }
          break;
        }
        that.verifData[v.name] = that.htmlEscape(v.value)
      })

      // 200 {"isDATAok": true, "primaryOk": true, "pin": "", "code" :"", "scenario": "residential" };
      // 200 {"isDATAok": true, "primaryOk": false, "nrTrunc": "", "code" :"", "scenario": "residential" };
      // 401 {"isDATAok": false, "failType": "general", "scenario": "residential" };
      // 401 {"isDATAok": false, "failType": "noContact", "scenario": "business" };
      // 200 {"isDATAok": true, "primaryOk": true, "pin": "", "code" :"", "scenario": "business" };
      // 401 {"isDATAok": false, "failType": "personNr", "scenario": "business" };
      // 401 {"isDATAok": false, "failType": "general", "scenario": "business" };
      // 401 {"isDATAok": false, "failType": "primaryNok", "scenario": "business" };
      // 401 {"isDATAok": false, "failType": "personNok", "scenario": "business" };
      // 401 {"isDATAok": false, "failType": "icoNok", "scenario": "business" };
      // 401 {"isDATAok": false, "failType": "roleNok", "scenario": "business" };
      if (formValid) {
        this.states.showMain = false
        this.formError = "&nbsp;" 
        this.$http.post(that.$store.state.validateCustSrc + "/" + that.bpn + "/" + that.states.token, that.verifData)     
        .then(function(resp){
          if (resp.data.scenario == 'residential') {
            if ((resp.data.primaryOk === true) && (resp.data.pin)) {
            that.formIntro = '<p class=\"text-center\"><strong>Váš ID kód je</strong></p><div class=\"text-center\">';
            if ((resp.data.pin).length < 2) {
              that.formIntro = '<p><strong>Zadané údaje sú správne. ID kód nemáte vytvorený. Kontaktujte <span style=\"white-space: nowrap;\">0800 123 456</span>.</strong></p>';	
            } else {
            var singleNr = (resp.data.pin).split('');
            _.each(singleNr, function (tv, tk) {
              that.formIntro += '<span class=\"resnr\"><strong>'+ tv +'</strong></span>';
            });
            var isCompany = "PID";
            if (that.scenarioType !== 'business') { isCompany = 'ID'; }
            that.formIntro += '</div><p>&nbsp;</p><p><strong>Dôležité</strong><div>' + isCompany + ' kód a kód adresáta predstavujú také overovacie faktory pri komunikácii s Telekomom, pri ktorých môžete spolu so svojimi osobnými identifikačnými údajmi vykonávať najzásadnejšie zmeny svojich služieb a iné citlivé aktivity. Na základe týchto údajov vieme overiť, že naozaj komunikujeme s vami. Prosím, uschovajte si ich a neposkytujte ich tretím osobám. Telekom nezodpovedá za prípadné škody, ktoré vám vzniknú poskytnutím alebo zneužitím týchto overovacích faktorov tretími osobami. Ak máte pocit, že došlo k zneužitiu alebo neoprávnenému získaniu vašich overovacích faktorov alebo osobných údajov, bezodkladne nás informujte za účelom nastavenia striktnejšieho prístupu k spravovaniu vašich služieb.</div></p>';
            }
          } else {
            that.formIntro = "<p>Prihlásené telefónne číslo 0" + that.msisdn + " neevidujeme ako kontaktné pre adresáta " + that.bpn + ".</p><p>Pre daného adresáta evidujeme kontaktné telefónne číslo  <span style=\"white-space: nowrap;\"><strong>**** *** " + resp.data.nrTrunc + ".</strong></span></p><p>Ak si na číslo **** *** " + resp.data.nrTrunc + " nespomínate, môžete si ho zmeniť na stránke <a href='/kontaktne-udaje' target='_top'>Aktualizácia kontaktných údajov</a>.</p>";
            that.retryText = "Prihlásiť sa evidovaným číslom";
          }
          that.dynForm = false
          that.retryMsisdn = true
          that.retryForm = false
          } else if ((resp.data.scenario == 'business') && (resp.data.isDATAok === true) && (resp.data.pin !== undefined)) {
            that.formIntro = '<p class=\"text-center\"><strong>Váš PID kód je</strong></p><div class=\"text-center\">';
            if ((resp.data.pin).length < 2) {
              let phoneItem = "<span style=\"white-space: nowrap;\">0800 123 500</span>";
              if (window.innerWidth < 490) {
                phoneItem = "<span style=\"white-space: nowrap;\"><a href=\"tel:0800123500\">0800 123 500</a></span>";
              }
              that.formIntro = '<p><strong>Zadané údaje sú správne. Váš PID kód zatiaľ nebol vygenerovaný, preto ho nie je možné zobraziť. Pre vygenerovanie PID kódu, prosím, kontaktujte Biznis linku ' + phoneItem + '.</strong></p>';	
            } else {
            var singleNr = (resp.data.pin).split('');
            $.each(singleNr, function () {
              that.formIntro += '<span class=\"resnr\"><strong>'+ this +'</strong></span>';
            });
            that.formIntro += '</div>';
            }
            that.dynForm = false
            that.retryMsisdn = false
            that.retryForm = false
          } else {
						that.formError = 'CHYBA SPRACOVANIA.'			
          }
        })
        .catch(function(err) {
          that.formError = '&nbsp;'		
					if (err.response.status === 403) {
						that.formError = 'Prihlásenie exspirovalo.'			
          } else if (err.response.status === 401) {
            if (err.response.data.scenario == 'business') {
            that.retryMsisdn = false
            that.retryForm = false
              switch(err.response.data.failType) {
                case 'noContact':
                    that.formIntro = 'Ľutujeme, PID kód nie je možné zobraziť. Pre zadané IČO neevidujeme žiadne oprávnené osoby. Kontaktujte biznis linku <span style=\"white-space: nowrap;\">0800 123 500</span> alebo navštívte ktorékoľvek <a target=\"_top\" href=\"https://www.telekom.sk/predajne\">Telekom Centrum</a> za účelom aktualizácie Vašich kontaktných údajov v našom systéme.'
                    that.retryMsisdn = true
                  break
                case 'personNok':
                    that.formIntro = 'Zadané meno a priezvisko nie sú evidované ako údaje oprávnenej osoby konať za IČO. Zadajte správne meno a priezvisko kontaktnej osoby. Inak kontaktujte biznis linku <span style=\"white-space: nowrap;\">0800 123 500</span> alebo navštívte ktorékoľvek <a target=\"_top\" href=\"https://www.telekom.sk/predajne\">Telekom Centrum</a> za účelom aktualizácie Vašich kontaktných údajov v našom systéme.'
                    that.retryForm = true
                  break
                case 'primaryNokBusinessNok':
                  that.formIntro = 'Zadané telefónne číslo nie je evidované ako kontaktné telefónne číslo oprávnenej osoby. Zadajte, prosím, správne kontaktné číslo. Inak kontaktujte Zákaznícku linku pre podnikateľov a firmy <span style=\"white-space: nowrap;\">0800 123 500</span> alebo navštívte ktorékoľvek <a target=\"_top\" href=\"https://www.telekom.sk/predajne\">Telekom Centrum</a> za účelom aktualizácie svojich kontaktných údajov v našom systéme.'
                  that.retryMsisdn = true
                break
                case 'primaryNok':
                    that.formIntro = 'Zadané telefónne číslo nie je evidované ako kontaktné telefónne číslo. Zadajte, prosím, správne kontaktné číslo. Inak kontaktujte Zákaznícku linku pre podnikateľov a firmy <span style=\"white-space: nowrap;\">0800 123 500</span> alebo navštívte ktorékoľvek <a target=\"_top\" href=\"https://www.telekom.sk/predajne\">Telekom Centrum</a> za účelom aktualizácie svojich kontaktných údajov v našom systéme.';
                    that.retryMsisdn = true
                  break
                case 'roleNok':
                    that.formIntro = 'Ospravedlňujeme sa, ale týmto spôsobom Vám nevieme zobraziť PID kód. Kontaktujte prosím Zákaznícku linku pre podnikateľov a firmy <span style=\"white-space: nowrap;\">0800 123 500</span> alebo navštívte ktorékoľvek <a target=\"_top\" href=\"https://www.telekom.sk/predajne\">Telekom Centrum</a> a my Vám PID kód zašleme.'
                    that.retryMsisdn = true
                break
                default: 
                    that.formIntro = 'Zadané údaje (tel. číslo a meno a priezvisko kontaktnej osoby) nie sú evidované ako údaje oprávnenej osoby konať za IČO. Zadajte prosím správne údaje. Inak kontaktujte biznis linku <span style=\"white-space: nowrap;\">0800 123 500</span> alebo navštívte ktorékoľvek <a target=\"_top\" href=\"https://www.telekom.sk/predajne\">Telekom Centrum</a> za účelom aktualizácie Vašich kontaktných údajov v našom systéme.'
                    that.retryForm = true
              }  
            } else {
            that.formIntro = '<p>Ľutujeme, ID kód nie je možné zobraziť. Pravdepodobne ste zadali <b>nekorektné identifikačné údaje</b> vlastníka, na ktorého je služba evidovaná. Opakujte, prosím, postup a zadajte správne identifikačné údaje.<br><br>Ak došlo <b>k zmene zmluvných údajov</b> (napr. zmena priezviska), je potrebná <b>osobná návšteva predajne</b>, za účelom aktualizácie osobných údajov.<br><br>V prípade opakovaného neúspešného overenia nás kontaktujte na bezplatnom čísle <a href="tel:0800123456" style=\"white-space: nowrap;\">0800 123 456</a>.</p>';
            that.retryMsisdn = false
            that.retryForm = true
            }
            that.dynForm = false
          } else {
						that.formError = 'CHYBA SPRACOVANIA.'			
          }
        })
        .finally(function(){
          that.states.showMain = true
        })
      } else {
        if (failCount > 1) {
          that.formError = "Zvýraznené polia nie sú správne vyplnené." 
        } else {
          that.formError = "Zvýraznené pole nie je správne vyplnené." 
        }
      }
    },
    htmlEscape: function (str) {
			return str.replace(/\&/g, '&amp;').replace(/\"/g, '&quot;').replace(/\'/g, '&#39;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;');
		}
  }
}
</script>

<style scoped>
.dashboard {
  max-width: 940px;
}
.magenta {
  color: #e20074;
}

input.invalid {
  border-width: 1px 4px;
  border-color: #e20074;
}

input.invalid:focus {
  border-color:#e20074;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

</style>
